import Vue from 'vue';
import VueI18n from 'vue-i18n';
import SVGInjectorVue from 'svginjector-vue';
import globals from './globals.js';
import App from './App.vue';
import './assets/global.css';

Vue.config.productionTip = false

import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export const eventBus = new Vue();

Vue.use(globals);
Vue.use(SVGInjectorVue);
Vue.use(VueI18n);

// Create VueI18n instance with options
export const i18n = new VueI18n();

// Create a Vue instance with `i18n` option
new Vue({
  i18n,
  render: h => h(App)
}).$mount('#ecm');
